<template>
    <div id="reportData">
        <div class="con">
            <img class="imgborder" src="../../assets/project/add-border.png" alt="">
            <div class="details">
                <div class="close" @click="close('ruleForm')">
                    <img src="../../assets/vehicleData/close.png" alt="">
                </div>
                <div class="title">
                    <img src="../../assets/project/project-left.png" alt="">
                    <span class="text">数据上报</span>
                    <img src="../../assets/project/project-right.png" alt="">
                </div>
                <div class="line"><img src="../../assets/vehicleData/line.png" alt=""></div>
                <div class="content">
                    <div class="content-item">
                        <div class="top">
                            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" :validate-on-rule-change="false">
                                <div style="display:flex;justify-content: space-between;">
                                    <el-form-item prop="year" style="width:30%">
                                        <div class="project-add-header">选择年份</div>
                                        <el-date-picker
                                                v-model="ruleForm.year"
                                                type="year"
                                                placeholder="选择年份"
                                                value-format="yyyy"
                                                style="width:100%;">
                                        </el-date-picker>
                                    </el-form-item>
                                    <el-form-item prop="num" style="width:30%">
                                        <div class="project-add-header">保有量</div>
                                        <el-input placeholder="请输入保有量" v-model.number="ruleForm.num" style="width:100%;" clearable>
                                            <i
                                                    class=" el-input__icon"
                                                    slot="suffix">
                                                辆
                                            </i>
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item prop="mechanizationLevel" style="width:30%">
                                        <div class="project-add-header">机械化率</div>
                                        <el-input placeholder="请输入机械化率" v-model="ruleForm.mechanizationLevel" style="width:100%;" clearable>
                                            <i
                                                    class=" el-input__icon"
                                                    slot="suffix">
                                                %
                                            </i>
                                        </el-input>
                                    </el-form-item>
                                </div>
                                <div style="">
                                    <div class="project-add-header">
                                        农作物(可多选)
                                        <img style="width:16px;vertical-align: middle;" @click="moduleAdd()" src="../../assets/project/add-icon.png" alt="">
                                        <img style="width:16px;vertical-align: middle;margin-left:5px;"  @click="moduleDel()" src="../../assets/project/delete-icon.png" alt="">
                                    </div>
                                    <el-table :data="ruleForm.cropData" ref="moduleTable" @selection-change="moduleSelectionChange" :row-style="{height:'60px'}" :header-row-style="{height:'40px'}" :cell-style="{padding:'0px'}" :header-cell-style="{textAlign: 'center'}">
                                        <el-table-column type="selection" width="55" align="center">
                                        </el-table-column>
                                        <!--                                            <el-table-column label="序号" type="index" align="center">-->
                                        <!--                                            </el-table-column>-->
                                        <el-table-column label="农作物" style="width:200" align="center">
<!--                                            <template slot-scope="scope">-->
<!--                                                <el-form-item :prop="'cropData.' + scope.$index + '.cropId'" :rules="rules.cropId">-->
<!--                                                    <el-select filterable v-model="ruleForm.cropData[scope.$index].cropId" placeholder="请选择农作物" @change="selectModule" clearable  style="width: 100%">-->
<!--                                                        <el-option v-for="item in cropType" :key="item.id" :label="item.name" :value="item.id" :disabled="item.disabled">-->
<!--                                                        </el-option>-->
<!--                                                    </el-select>-->
<!--                                                </el-form-item>-->
<!--                                            </template>-->
                                            <template slot-scope="scope">
                                                <el-form-item :prop="'cropData.' + scope.$index + '.cropId'" :rules="rules.cropId">
                                                    <el-cascader :options="options" :props="cateListProps" :show-all-levels="false" v-model="ruleForm.cropData[scope.$index].cropId" placeholder="请选择农作物" @focus="focus" @change="selectModule" clearable>
                                                    </el-cascader>
                                                </el-form-item>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="机械化率" style="width:200" align="center">
                                            <template slot-scope="scope">
                                                <el-form-item :prop="'cropData.' + scope.$index + '.mechanizationRate'" :rules="rules.mechanizationRate">
                                                    <el-input v-model="ruleForm.cropData[scope.$index].mechanizationRate" placeholder="请输入机械化率" style="width: 100%">
                                                        <i
                                                                class=" el-input__icon"
                                                                slot="suffix">
                                                            %
                                                        </i>
                                                    </el-input>
                                                </el-form-item>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </el-form>
                        </div>
                        <div  class="bottom">
                            <div class="project-button "  @click="resetForm('ruleForm')">
                                <div class="project-button-text">取消</div>
                            </div>
                            <el-button type="primary" :loading="true" v-if="Loading" class="project-button project-button2">提交中</el-button>
                            <div v-else class="project-button project-button2" @click="submitForm('ruleForm')">
                                <div class="project-button-text">提交</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import eventBus from "../../eventBus";
    import WitVehicleStatisticsService from '../../services/jaxrs/concrete/com.zny.eop.witAgriculture.api.WitVehicleStatisticsService.js';
export default {
    data(){
        //输入验证
        const validateRate = (rule,value,callback) => {
            // console.log(rule,value)
            var reg = /^\d+$|^\d*\.\d+$/g
            if (!value) {
                callback(new Error('请输入机械化率'))
            } else if (value.indexOf(".") != -1 && value.split('.').length > 2) {
                callback(new Error('格式不正确')) //防止输入多个小数点
            } else if (value.indexOf(".") != -1 && value.split('.')[1].length > 2) {
                callback(new Error('请输入小数点后两位')) //小数点后两位
            } else if(!reg.test(value)){
                callback(new Error('请输入数字')) //数字
            } else if(Number(value)>100){
                callback(new Error('请输入小于100的数值')) //大于100
            }else {
                callback();
            }
        };
        return{
            cropType:[],//农作物类型
            ruleForm: {
                moduleSelection:[],
                year: '',
                num:'',
                mechanizationLevel:'',
                cropData:[
                    {
                        index:0,
                        cropId:"",
                        mechanizationRate:'',
                    }
                ]
            },
            rules: {
                year: [
                    { required: true, message: '请选择年份', trigger: 'change' },
                ],
                num: [
                    { required: true, message: '请输入保有量', trigger: 'blur' },
                    { type: 'number', message: '保有量必须为数字值'},
                ],
                mechanizationLevel: [
                    { type:'string',required: true,trigger: 'blur',validator:validateRate },
                ],
                mechanizationRate:[
                    { type:'string',required: true,trigger: 'blur',validator:validateRate }
                ],
                cropId: [
                    { required: true, message: '请选择农作物', trigger: 'change' }
                ],
            },
            options: [],//农作物下拉选列表
            cateListProps:{
                value: 'id',                 //匹配响应数据中的id
                label: 'name',               //匹配响应数据中的name
                children: 'children',         //匹配响应数据中的children
                emitPath:false,//只存最后一级的值
                // disabled:'disabled',//禁用显示
            },
            Loading:false,
        }
    },
    mounted() {
        var that = this
        that.getCropList()
    },
    methods:{
        getCropList(){
            var that = this
            WitVehicleStatisticsService.cropsList()
            .then(res=>{
                that.options=res
            })
        },
        focus(){
            var that = this
            for(var i=0;i<that.options.length;i++){
                for(var j=0;j<that.options[i].children.length;j++){
                    delete that.options[i].children[j].disabled
                }
            }
            for(var i=0;i<that.ruleForm.cropData.length;i++){
                for(var j=0;j<that.options.length;j++){
                    for(var l=0;l<that.options[j].children.length;l++){
                        if(that.options[j].children[l].id==that.ruleForm.cropData[i].cropId){
                            that.options[j].children[l].disabled=true
                        }
                    }
                }
            }
        },
        // 作业类型 单价 选中变化
        moduleSelectionChange(val){
            this.ruleForm.moduleSelection = val;
        },
        // 选择类型
        selectModule(val){
            var that = this
            for(var i=0;i<that.options.length;i++){
                for(var j=0;j<that.options[i].children.length;j++){
                    delete that.options[i].children[j].disabled
                    that.$set(that.options,i,that.options[i]);
                }
            }
            for(var i=0;i<that.ruleForm.cropData.length;i++){
                for(var j=0;j<that.options.length;j++){
                    for(var l=0;l<that.options[j].children.length;l++){
                        if(that.options[j].children[l].id==that.ruleForm.cropData[i].cropId){
                            that.options[j].children[l].disabled=true
                            that.$set(that.options,j,that.options[j]);
                        }
                    }
                }
            }
        },
        //作业类型 单价 批量清除
        moduleDel(){
            var that = this
            if(!this.isAssign){
                // 拿到选中的数据；
                var val = that.ruleForm.moduleSelection
                // 所有数据
                var val2 = that.ruleForm.cropData
                // 如果选中数据存在
                if (val) {
                    // 将选中数据遍历
                    val.forEach(function (item, index) {
                        // 遍历源数据
                        val2.forEach(function (itemI, indexI) {
                            // 如果选中数据跟元数据某一条标识相等，删除对应的源数据
                            if (item.index == itemI.index) {
                                val2.splice(indexI, 1)
                            }
                            //如果全部清除，需要保留一个初始数据
                            if(val2.length==0){
                                that.ruleForm.cropData=[{
                                    index:0,
                                    cropId:"",
                                    mechanizationRate:""
                                }]
                            }
                        })
                    })
                }
                val2.forEach(function (itemI, indexI) {
                    itemI.index = indexI
                })
                // 清除选中状态
                this.$refs.moduleTable.clearSelection()
            }
        },
        // 作业类型 单价 添加
        moduleAdd(){
            let row = {
                index:this.ruleForm.cropData.length,
                cropId:"",
                mechanizationRate:""
            }
            this.ruleForm.cropData.push(row)
        },
        // 点击关闭
        close(formName){
            this.$refs[formName].resetFields();
            this.$store.state.add=''
            this.$store.state.list='centerBot'
        },
        // 取消
        resetForm(formName){
            this.$refs[formName].resetFields();
            this.$store.state.add=''
        },
        // 提交
        submitForm(formName){
            var that=this
            that.$refs[formName].validate((valid) => {
                if (valid) {
                    that.Loading=true
                    var dataList=that.ruleForm.cropData
                    for(var i=0;i<dataList.length;i++){
                        delete dataList[i].index
                    }
                    var vehicleData={
                        year:that.ruleForm.year,
                        num:that.ruleForm.num,
                        mechanizationLevel:that.ruleForm.mechanizationLevel,
                        reportingCropsPoList:dataList
                    }
                    WitVehicleStatisticsService.addVehicleData(vehicleData)
                    .then((res)=>{
                        that.Loading=false
                        // console.log(res)
                        if(res){
                            that.$message({
                                type: 'success',
                                message: "提交成功!"
                            });
                            that.$nextTick(function () {
                                setTimeout(function () {
                                    eventBus.$emit('reportDataSuccess')
                                },500)
                            })
                            that.$refs[formName].resetFields();
                            that.$store.state.add=''
                        }else{
                            that.$message.error("操作失败!");
                        }
                    })
                    .catch(err=>{
                        that.Loading=false
                    })
                }
            })
        },
    },
}
</script>
<style lang="less">
@import '../../viewsStyle/vehicleData/reportData.less';

</style>